





























import eventBus from "@/utils/bus";
import { modifysort } from "@/api/teacherManage";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
@Component
export default class extends Vue {
  @Prop() id!: number;
  @Prop() ori!: number;
  currentSort: number = 0;
  saveSort: number = 0;
  editing: boolean = false;
  created() {
    this.currentSort = this.ori || 0;
    this.saveSort = this.ori || 0;
    eventBus.$on("teacherManageSortEdit", (i: number) => {
      if (i !== this.id) {
        this.currentSort = this.saveSort;
        this.editing = false;
      }
    });
  }
  toggleEditing() {
    if (!this.editing) {
      eventBus.$emit("teacherManageSortEdit", this.id);
    }
    this.editing = !this.editing;
  }
  // 禁止输入小数点
  notDecimals(e: { key: string; returnValue: boolean }) {
    // console.log(e);
    const key = e.key;
    if (key === ".") {
      e.returnValue = false;
    }
    return;
  }
  saveEditing() {
    if (!this.id) {
      return false;
    }
    if (
      typeof this.currentSort !== "number" ||
      this.currentSort < 0 ||
      JSON.stringify(this.currentSort) == ""
    ) {
      this.$message({
        type: "error",
        message: "请填写正整数",
      });
      return;
    }
    modifysort({
      staff_id: this.id,
      sort: this.currentSort,
    }).then((res: any) => {
      this.toggleEditing();
      if (res.error_code == 0) {
        this.$message({
          type: "success",
          message: "修改成功!",
        });
        this.saveSort = this.currentSort;
      } else {
        this.$message({
          type: "error",
          message: "修改失败!" + res.message,
        });
        this.currentSort = this.ori || 0;
      }
    });
  }
  @Watch("ori", { immediate: false, deep: false })
  originChange(n: any, o: any) {
    this.currentSort = n || 0;
    this.saveSort = n || 0;
  }
}
